import React from "react";

export default class ReadMoreButton extends React.Component {

	render() {
		return <a href={this.props.url}>
            <div className={"read-more-button "+this.props.color}></div>
        </a>;
	}

}
